import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const DropdownLink = styled(Link)`
  width: 100%;
  height: 36px;

  white-space: nowrap;
  padding: 9px;
  background-color: transparent;
  cursor: pointer;
  border: none;
  text-align: start;

  display: flex;
  align-items: center;
  gap: 12px;

  font-family: ${({theme}) => theme.old.fonts.family.primary};
  font-weight: ${({theme}) => theme.old.fonts.weight.regular};
  font-size: ${({theme}) => theme.old.fonts.size.normal};

  border-radius: 8px;
  color: ${({ $isCreators, theme, color }) => theme.old.colors[color] || ($isCreators ? 'black' : 'white')};
  transition: background-color 200ms;

  svg {
    height: 20px;
    width: 20px;
    opacity: 0.5;
    transition: 150ms;
  }
  
  ${({ $isFocused }) => $isFocused && css`
    background-color: ${({ theme, $isCreators }) => $isCreators
      ? theme.old.colors.gray[800]
      : '#27272A'
    };

    svg {
      opacity: 1;
    }
  `}

  :hover {
    background-color: ${({ theme, $isCreators }) => $isCreators
      ? theme.old.colors.gray[800]
      : '#27272A'
    };

    svg {
      opacity: 1;
    }
  }

  ${({ theme, $isCreators }) => {
    if ($isCreators) return

    return css`
      ${theme.old.breakpoints.isTab} {
        font-weight: ${({theme}) => theme.old.fonts.weight.regular};
        font-size: ${({theme}) => theme.old.fonts.size.large};
        padding: 13px 12px;
      }

      ${theme.old.breakpoints.isMobile} {
        font-weight: ${({theme}) => theme.old.fonts.weight.regular};
        font-size: ${({theme}) => theme.old.fonts.size.normal};
      }
    `
  }}
`